import { useLocation } from 'react-router-dom';
import BaseError from './BaseError';
import { CalendarRegularGlyph } from '@acast-tech/decibel-glyphs';

const NoDataMessage = ({ dataType }: { dataType: string }) => {
  const location = useLocation();
  const isEarningsPage = location.pathname.includes('earnings');
  const description = isEarningsPage
    ? 'Once campaigns are live, it may take one to two days to start displaying daily earnings, depending on your timezone.'
    : '';

  return (
    <BaseError
      // TODO: Generate CalendarExclamationRegularGlyph in Decibel Glyphs and import here
      icon={<CalendarRegularGlyph />}
      title={`No ${dataType} found for this period`}
      desc={description}
    />
  );
};

export default NoDataMessage;
